(function(module) {
try {
  module = angular.module('pipLists.Templates');
} catch (e) {
  module = angular.module('pipLists.Templates', []);
}
module.run(['$templateCache', function($templateCache) {
  $templateCache.put('tag_list/TagList.html',
    '<div class="pip-chip rm4 pip-type-chip pip-type-chip-left {{\'bg-\' + $ctrl.type + \'-chips\'}}"\n' +
    '     ng-if="$ctrl.type && !$ctrl.typeLocal">\n' +
    '\n' +
    '    <span>{{$ctrl.type.toUpperCase() | translate | uppercase}}</span>\n' +
    '</div>\n' +
    '<div class="pip-chip rm4 pip-type-chip pip-type-chip-left {{\'bg-\' + $ctrl.type + \'-chips\'}}"\n' +
    '     ng-if="$ctrl.type && $ctrl.typeLocal">\n' +
    '\n' +
    '    <span>{{$ctrl.typeLocal.toUpperCase() | translate | uppercase}}</span>\n' +
    '</div>\n' +
    '<div class="pip-chip rm4" ng-repeat="tag in $ctrl.tags">\n' +
    '    <span>{{::tag}}</span>\n' +
    '</div>');
}]);
})();

//# sourceMappingURL=pip-webui-lists-html.js.map
